import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";

const OnboardingGuardLogic = () => {
  const [grantAccess, setGrantAcces] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("refreshToken"))
      navigate(pathConstants.DASHBOARD_MAIN);
    setGrantAcces(true);
  }, []);
  return { grantAccess };
};

export default OnboardingGuardLogic;
